import { render, staticRenderFns } from "./Occassions.vue?vue&type=template&id=0e60748b"
import script from "./Occassions.vue?vue&type=script&lang=ts"
export * from "./Occassions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports